import { combineReducers } from '@reduxjs/toolkit'
import tenantSlice from './slices/tenantSlice';
import authSlice from './slices/auth';
import chatSlice from './slices/chatSlice';
import aiAgentStatesSlice from './slices/aiAgentStatesSlice';

const rootReducer = combineReducers({
    auth: authSlice,
    chat: chatSlice,
    aiAgentStates: aiAgentStatesSlice,
    tenant: tenantSlice,
})

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer